/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/",
    name: "Home",
    i18n: "sections.home.title",
    slug: "home",
    icon: "HomeIcon",
  },
  {
    url: "/liveschedule",
    name: "LiveSchedule",
    i18n: "sections.liveschedule.title",
    slug: "liveschedule",
    icon: "ClockIcon",
  },
  {
    url: "/advisor-online-schedule",
    name: "Advisor OnlineSchedule",
    i18n: "sections.advisor-online-schedule.title",
    slug: "advisor-online-schedule",
    icon: "CalendarIcon",
  },
  // {
  //   url: "/e-learning",
  //   name: "E-Learning",
  //   i18n: "sections.e-learning.nav",
  //   slug: "e-learning",
  //   icon: "PersonIcon",
  //   submenu: [
  //     {
	// 			url: '/e-learning/registered-course',
	// 			name: "รายวิชาที่ลงทะเบียน",
	// 			i18n: "sections.e-learning.registered-course.nav",
	// 			slug: "registered-course",
	// 		}
  //   ]
  // }
]
